import { cn } from '@/utils';
import { ContainerProps } from './Container.interfaces';
import { ESize } from '@/models/enums';

export const Container = ({
  additionalClassNames,
  children,
  size = ESize.MD,
  spacingBottom,
  spacingTop,
  verticalSpacing = ESize.NONE,
}: ContainerProps) => {
  return (
    <div
      className={cn([`c-container c-container--${size}`], {
        [`c-container--py-${verticalSpacing}`]: Boolean(verticalSpacing),
        [`c-container--pb-${spacingBottom}`]: Boolean(spacingBottom),
        [`c-container--pt-${spacingTop}`]: Boolean(spacingTop),
        [String(additionalClassNames)]: Boolean(additionalClassNames),
      })}
    >
      {children}
    </div>
  );
};
